import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ExpandableGrid from '@prisjakt/ui-expandable-grid';
import StoreLogo from '@prisjakt/ui-store-logo';
import ShopRating from '../shop-rating';

import { ViewportContext } from '../../../../../../components/viewport';

import { Store } from '../../../../../../types';
import { UserReview } from '../../../../../reviews/types';

import { SHOP_LOGO_WIDTH } from '../../../../../store/constants';

import * as S from './styles';

type OwnProps = {
  reviews: UserReview[];
  shops: (Store | null)[];
};

const RatedShops = ({ reviews, shops }: OwnProps) => {
  const { linkTo, t, renderMode } = useContext(AppContext);
  const { isDesktop } = useContext(ViewportContext);

  return (
    <S.RatedShops>
      <S.Main>
        <S.Title>
          <h3>{t('campaigns', 'shop-of-the-year.latest-shops-title')}</h3>
          <p>{t('campaigns', 'shop-of-the-year.latest-shops-subtitle')}</p>
        </S.Title>

        <S.ShopSection>
          <ExpandableGrid
            expandText={t('common', 'button.show-more')}
            collapseText={t('common', 'button.show-less')}
            limit={isDesktop ? 10 : 4}
            items={shops.map(shop => {
              if (!shop?.userReviewSummary.rating) return null;

              const highResolutionLogo = shop.logo
                ? { url: shop.logo, width: SHOP_LOGO_WIDTH }
                : null;

              return (
                shop && (
                  <S.ShopCardWrapper>
                    <S.ShopCard
                      to={linkTo('store', shop, { review: 'write' })}
                      isExternal={renderMode === 'native'}
                    >
                      <StoreLogo
                        storeId={shop.id}
                        name={shop.name}
                        featured={Boolean(shop.featured)}
                        hasImage={Boolean(shop.hasLogo)}
                        logoUrl={highResolutionLogo?.url}
                        width={highResolutionLogo?.width}
                        showHighResolutionLogo={Boolean(highResolutionLogo)}
                      />
                      <ShopRating rating={shop.userReviewSummary.rating} />
                    </S.ShopCard>
                  </S.ShopCardWrapper>
                )
              );
            })}
          />
        </S.ShopSection>
      </S.Main>

      <S.Sidebar>
        <S.Title>
          <h3>{t('campaigns', 'shop-of-the-year.latest-reviews-title')}</h3>
        </S.Title>

        <S.ReviewSection>
          {reviews.map(
            (review, index) =>
              review.store &&
              index < 3 && (
                <S.UserReviewCard
                  key={review.id}
                  id={review.id}
                  type="store"
                  text={review.reviewText}
                  rating={review.rating}
                  purchaseDate={review.purchaseDate}
                  createdAt={review.createdAtFromNow}
                  updatedAt={review.updatedAtFromNow}
                  likes={review.likeScore}
                  store={review.store}
                  belongsTo={{
                    type: 'store',
                    id: review.store.id,
                    name: review.store.name,
                  }}
                  hideFooter
                />
              )
          )}
        </S.ReviewSection>
      </S.Sidebar>
    </S.RatedShops>
  );
};

export default RatedShops;
